<template>
  <div class="article">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="6.7rem" top="47.9rem" left="14.2rem" color="orange" />
      <Cross class="mobile-hidden" img-width="4.5rem" top="57.8rem" right="7.7rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="27.5rem" left="26rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="7.4rem" top="17.8rem" left="65rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="25.1rem" right="9.4rem" color="orange" />
      <Snowflake3 class="mobile-hidden" img-width="6.9rem" bottom="22.5rem" left="61.8rem" color="orange" />
      <Snowflake3 class="mobile-hidden" img-width="5.4rem" bottom="7rem" left="16.2rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" bottom="10.2rem" right="12.5rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="9.8rem" left="50rem" />
      <Tree2 class="mobile-hidden" img-width="9.8rem" top="24.9rem" left="13rem" />
      <Star2 class="mobile-hidden" img-width="4.7rem" bottom="23.4rem" left="8rem" />
    </div>

    <div class="article__img">
      <img class="mobile-hidden" src="@/assets/img/article2.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article2-mob.png" alt="">
    </div>
    <div class="article__content">
      <h2 class="article__title">
        {{ 'Как волонтерство изменило' | typograf }}
      </h2>
      <h2 class="article__title">
        {{ 'жизнь деревни Пятково' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'Сначала в деревне Пятково появился волонтерский отряд: нужно помогать бабушкам и дедушкам, им трудно самостоятельно справляться с хозяйством.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Сейчас в работу отряда вовлечены многие жители деревни. Инициаторы местного волонтерского движения Ольга и Вероника рассказали «Ленте.ру» о развитии добровольчества в деревне и об участии в акциях #МЫВМЕСТЕ.' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/articles/2021/12/17/volonterpyatkovo" target="_blank">
          <button @click="gtmSend" class="button button--orange">Читать специальный материал</button>
        </a>
      </div>

      <ArticleFooter />
    </div>
  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";
  import Snowflake2 from "../Elements/Snowflake2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Snowflake3 from "../Elements/Snowflake3";
  import Gift4 from "../Elements/Gift4";
  import Star2 from "../Elements/Star2";
  export default {
    name: "Article2",
    components: {Star2, Gift4, Snowflake3, Tree2, Gift3, ArticleFooter, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch2_link_lenta_ru',
          'event_label': 'chapter_2'
        });
        window.ym(86974684, 'reachGoal', 'ch2_link_lenta_ru/click/chapter_2');
      }
    }
  }
</script>

<style scoped>

</style>
